import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {getStudentUserStatusType} from "./__graphql-types__/index.ts";

/**
 * TODO(somewhatabstract, CLASS-7043): This query does not include the fields
 * required to satisfy the `LoginUserData` type that it is used for.
 * I expect this may lead to some issues.
 */
export const userProfileQuery: GqlOperation<
    getStudentUserStatusType["response"],
    getStudentUserStatusType["variables"]
> = gqlOp(gql`
    query getStudentUserStatus {
        user {
            id
            nickname
            age
            birthdate
            cleverId
            userDistrictInfos {
                id
            }
        }
    }
`);
